
import { SubscriptionKeys } from '@/i18n/types/subscription.types';

export const subscription: Record<SubscriptionKeys, string> = {
  subscription: 'Subscription',
  freePlan: 'Free Plan',
  premiumPlan: 'Premium Plan',
  proPlan: 'Pro Plan',
  businessPlan: 'Business Plan',
  currentPlan: 'Current Plan',
  managePlan: 'Manage Plan',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  subscribe: 'Subscribe',
  unsubscribe: 'Unsubscribe',
  subscriptionFeatures: 'Features',
  subscriptionPrice: 'Price',
  billingInfo: 'Billing Info',
  month: 'month',
  free: 'Free',
  nextBillingDate: 'Next Billing',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  cancelling: 'Cancelling',
  updatePaymentMethod: 'Update Payment',
  cancelSubscription: 'Cancel Subscription',
  cancelSubscriptionConfirmation: 'Are you sure you want to cancel your subscription?',
  cancelSubscriptionWarning: 'Your subscription will remain active until the end of the current period but will not auto-renew.',
  confirmCancellation: 'Confirm Cancellation',
  subscriptionCancelled: 'Subscription Cancelled',
  subscriptionWillEndOn: 'Your subscription will end on {date}',
  cancellationError: 'Cancellation Error',
  couldNotCancelSubscription: 'Could not cancel subscription. Please try again.',
  processing: 'Processing',
  paymentMethods: 'Payment Methods',
  addPaymentMethod: 'Add Payment Method',
  noPaymentMethodsYet: 'You haven\'t added any payment methods yet',
  expiresOn: 'expires on',
  edit: 'Edit',
  billingHistory: 'Billing History',
  subscriptionHistory: 'History',
  subscriptionPlans: 'Plans',
  otherSessionsClosed: 'Other sessions closed',
  successfullyLoggedOutOtherDevices: 'Successfully logged out from other devices',
  logoutError: 'Logout Error',
  couldNotLogoutOtherSessions: 'Could not logout other sessions',
  loggingOut: 'Logging out',
  logoutOtherSessionsConfirm: 'Logout other sessions',
  tryAgainLater: 'Please try again later.',
  upgradeToPremium: 'Upgrade to Premium',
  premiumFeature: 'Premium Feature',
  upgradeToUsePremiumFeature: 'Upgrade to Premium to use this feature and unlock all advanced tools.',
  subscribeWithCard: 'Subscribe', // Changed from "Subscribe with Card"
  subscribeWithPaypal: 'Subscribe with PayPal',
  payWith: 'Subscribe with PayPal',
  creatingSubscription: 'Creating subscription...',
  loadingPaypal: 'Loading PayPal...',
  subscriptionSuccessful: 'Subscription Successful',
  subscriptionSuccessMessage: 'You\'ve successfully subscribed to {plan}!',
  paypalError: 'PayPal Error',
  paypalErrorMessage: 'There was an error processing your subscription. Please try again.',
};
